export const focusSearchInput = () => {
  const input: HTMLInputElement | null = document.querySelector('input[data-site-search]')

  if (input) {
    input.focus()
  }
}
